var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageNumberGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "gray",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4h10a1 1 0 010 2H5a1 1 0 110-2zm0 5h7a1 1 0 010 2H5a1 1 0 110-2zm0 5h3a1 1 0 010 2H5a1 1 0 010-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNumberGray);
export default __webpack_public_path__ + "static/media/page-number-gray.19eae7d1c4e07e1e767203a143bc6ee1.svg";
export { ForwardRef as ReactComponent };